import { useEffect } from "react";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Lightweight SEO head manager (no external deps).
 * Sets title, description, OG/Twitter tags, canonical, and optional JSON-LD.
 */
export default function SeoHead({ title, description, canonical, jsonLd, noindex }) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    if (canonical) setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (noindex) setMeta("name", "robots", "noindex,nofollow");
    else setMeta("name", "robots", "index,follow");
    setCanonical(canonical);

    // Remove any previously injected JSON-LD to guarantee no duplicates
    // (prevents "multiple aggregate ratings"-type duplication issues).
    document.head
      .querySelectorAll("script.seo-jsonld-dynamic")
      .forEach((el) => el.remove());

    const added = [];
    if (jsonLd) {
      const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      blocks.forEach((obj) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.className = "seo-jsonld-dynamic";
        s.text = JSON.stringify(obj);
        document.head.appendChild(s);
        added.push(s);
      });
    }
    return () => {
      added.forEach((s) => s.remove());
    };
  }, [title, description, canonical, jsonLd, noindex]);

  return null;
}
